import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();

  // Auth state is still being resolved — show branded splash
  if (user === null) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-[60vh] flex flex-col items-center justify-center gap-6 text-eduhu-inkSoft"
      >
        <img
          src="/logo.png"
          alt="EDUHUB"
          className="w-20 h-20 object-contain animate-pulse"
        />
        <div className="overline tracking-widest text-eduhu-inkSoft/60">
          Loading…
        </div>
      </div>
    );
  }

  // Not logged in — redirect to login with return URL
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Wrong role — redirect home
  if (role && (Array.isArray(role) ? !role.includes(user.role) : user.role !== role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
